import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { GraduationCap, Microscope, Award } from 'lucide-react';
export function AboutSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-16 md:py-24 bg-slate-50" id="about" data-id="element-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        <div className="flex flex-col lg:flex-row items-start gap-12" data-id="element-4">
          {/* Image Column */}
          <div className="w-full lg:w-1/3" data-id="element-5">
            <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-xl border-4 border-white" data-id="element-6">
              <img src="https://cdn.magicpatterns.com/uploads/5Rk82FQzqcVJkW3VxhvpdW/M-Ailawadi.jpg" alt="Dr. Maneesh Ailawadi" className="w-full h-full object-cover" data-id="element-7" />
            </div>
            <div className="mt-6 bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-8">
              <h3 className="font-bold text-slate-900 text-lg mb-2" data-id="element-9">
                Dr. Maneesh Ailawadi
              </h3>
              <p className="text-slate-600 text-sm mb-4" data-id="element-10">MD, FSSO</p>
              <div className="h-px w-full bg-slate-100 mb-4" data-id="element-11"></div>
              <p className="text-sm text-slate-500 italic" data-id="element-12">
                {t('"My goal is to provide safe, effective surgical care that helps patients reclaim their health and quality of life."', '"Mi objetivo es brindar atención quirúrgica segura y efectiva que ayude a los pacientes a recuperar su salud y calidad de vida."')}
              </p>
            </div>
          </div>

          {/* Content Column */}
          <div className="w-full lg:w-2/3" data-id="element-13">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-14">
              {t('About Dr. Ailawadi', 'Sobre el Dr. Ailawadi')}
            </h2>

            <div className="prose prose-slate max-w-none text-slate-600 mb-8" data-id="element-15">
              <p className="text-lg leading-relaxed mb-6" data-id="element-16">
                {t('Expert general and bariatric surgeon at Lehigh Valley Weight Loss in Allentown and Bethlehem, PA. Has helped thousands of people achieve better health with weight-loss surgery.', 'Cirujano general y bariátrico experto en Lehigh Valley Weight Loss en Allentown y Bethlehem, PA. Ha ayudado a miles de personas a lograr una mejor salud con cirugía de pérdida de peso.')}
              </p>

              <p className="mb-6" data-id="element-17">
                {t('Dr. Ailawadi has extensive experience operating on the stomach and esophagus, utilizing advanced minimally invasive techniques to ensure faster recovery and better outcomes for his patients.', 'El Dr. Ailawadi tiene amplia experiencia operando el estómago y el esófago, utilizando técnicas avanzadas mínimamente invasivas para asegurar una recuperación más rápida y mejores resultados para sus pacientes.')}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-18">
              <div className="bg-white p-5 rounded-lg border border-slate-100 shadow-sm" data-id="element-19">
                <div className="flex items-center mb-3" data-id="element-20">
                  <GraduationCap className="w-5 h-5 text-teal-600 mr-2" data-id="element-21" />
                  <h3 className="font-bold text-slate-900" data-id="element-22">
                    {t('Education', 'Educación')}
                  </h3>
                </div>
                <ul className="space-y-2 text-sm text-slate-600" data-id="element-23">
                  <li data-id="element-24">• BS Biology — Carnegie Mellon University</li>
                  <li data-id="element-25">• Medical School — Chicago Medical School</li>
                  <li data-id="element-26">
                    • Residency — University of Illinois College of Medicine
                  </li>
                </ul>
              </div>

              <div className="bg-white p-5 rounded-lg border border-slate-100 shadow-sm" data-id="element-27">
                <div className="flex items-center mb-3" data-id="element-28">
                  <Award className="w-5 h-5 text-teal-600 mr-2" data-id="element-29" />
                  <h3 className="font-bold text-slate-900" data-id="element-30">
                    {t('Fellowship & Research', 'Fellowship e Investigación')}
                  </h3>
                </div>
                <ul className="space-y-2 text-sm text-slate-600" data-id="element-31">
                  <li data-id="element-32">
                    • Fellowship — Thoracic Surgery at Vanderbilt University
                  </li>
                  <li data-id="element-33">• Research — Memorial Sloan Kettering Cancer Center</li>
                </ul>
              </div>
            </div>

            <div className="bg-teal-50 p-6 rounded-xl border border-teal-100" data-id="element-34">
              <h3 className="font-bold text-teal-900 mb-3" data-id="element-35">
                {t('Approach to Care', 'Enfoque de atención')}
              </h3>
              <p className="text-teal-800/80" data-id="element-36">
                {t('Dr. Ailawadi believes in patient education, shared decision-making, and prioritizing safety above all else. Every treatment plan is tailored to the individual’s unique medical history and personal goals.', 'El Dr. Ailawadi cree en la educación del paciente, la toma de decisiones compartida y la priorización de la seguridad ante todo. Cada plan de tratamiento se adapta al historial médico único y los objetivos personales del individuo.')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}